// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Api from "../../../../core/Api.js";
import * as Buhta_cabinet__Crm from "../../../../models/Crm.js";
import * as Buhta_cabinet__LogoMaker from "../../../molecules/LogoMaker.js";
import * as Buhta_cabinet__Request from "../../../../core/Request.js";
import * as Buhta_components__Icons from "../../../../../../../packages/components/src/Icons.js";
import * as Buhta_components__LoadingDiv from "../../../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import AddressSvg from "static/icons/address.svg";
import ChashierSvg from "static/icons/chashier.svg";
import EmployeeSvg from "static/icons/employee.svg";
import MailSvg from "static/icons/mail.svg";
import MoreSvg from "static/icons/more.svg";
import PhoneSvg from "static/icons/phone.svg";
import TableSvg from "static/icons/table.svg";
import UserSvg from "static/icons/user.svg";

function tab_container(active) {
  return Cn.fromList({
              hd: "border-b flex justify-center items-center cursor-pointer",
              tl: {
                hd: active ? "border-links" : "border-gray-main",
                tl: /* [] */0
              }
            });
}

const Styles = {
  tab_container: tab_container
};

function make(currentTab) {
  return function (setCurrentTab) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("button", {
                              children: JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                    className: Cn.fromList({
                                          hd: "tab",
                                          tl: {
                                            hd: currentTab === /* Client */0 ? "text-links" : "text-gray-medium",
                                            tl: /* [] */0
                                          }
                                        }),
                                    children: "клиент"
                                  }),
                              className: tab_container(currentTab === /* Client */0),
                              onClick: (function (param) {
                                  Curry._1(setCurrentTab, (function (param) {
                                          return /* Client */0;
                                        }));
                                })
                            }),
                        className: "flex items-stretch -mt-px space-x-4"
                      }),
                  JsxRuntime.jsx("button", {
                        children: JsxRuntime.jsx(MoreSvg, {}),
                        className: "my-4"
                      })
                ],
                className: "flex justify-between items-stretch px-6 border-b border-gray-main h-14"
              });
  };
}

function HelpChatInfoPanel$PanelHeader(Props) {
  return make(Props.currentTab)(Props.setCurrentTab);
}

const PanelHeader = {
  make: HelpChatInfoPanel$PanelHeader
};

function make$1(title) {
  return function (itemsOpt) {
    const items = itemsOpt !== undefined ? itemsOpt : /* [] */0;
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                        className: "text-default-gray",
                        children: title
                      }),
                  JsxRuntime.jsx("div", {
                        children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(items, (function (index, item) {
                                    const Key = "section-item#" + String(index);
                                    return JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("div", {
                                                        children: item.icon,
                                                        className: "shrink-0"
                                                      }),
                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                        className: "text-gray-medium",
                                                        children: item.name
                                                      }),
                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                        children: item.value
                                                      })
                                                ],
                                                className: "flex items-center space-x-2"
                                              }, Key);
                                  }))),
                        className: "grid gap-2 mt-4"
                      })
                ],
                className: "mt-8"
              });
  };
}

function HelpChatInfoPanel$ClientInfo$Section(Props) {
  return make$1(Props.title)(Props.items);
}

const Section = {
  make: HelpChatInfoPanel$ClientInfo$Section
};

function HelpChatInfoPanel$ClientInfo(Props) {
  let orgId = Props.orgId;
  const org = Buhta_cabinet__Request.useFetch(Curry._2(Buhta_cabinet__Api.Endpoints.Crm.orgs, orgId, undefined), Buhta_cabinet__Crm.OrgSummary.decode, undefined);
  if (typeof org === "string") {
    return JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {});
  }
  if (org.NAME !== "Data") {
    return "Error: " + org.VAL.message;
  }
  const org$1 = org.VAL;
  const __x = org$1.organts;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_cabinet__LogoMaker.make, {
                              name: org$1.org.name
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                              className: "mt-4",
                              children: org$1.org.name
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "mt-1 text-gray-medium",
                              children: org$1.org.address
                            })
                      ],
                      className: "flex flex-col items-center"
                    }),
                JsxRuntime.jsx(HelpChatInfoPanel$ClientInfo$Section, {
                      title: "детали",
                      items: {
                        hd: {
                          icon: JsxRuntime.jsx(EmployeeSvg, {}),
                          name: "БИН",
                          value: org$1.org.bin
                        },
                        tl: {
                          hd: {
                            icon: JsxRuntime.jsx(TableSvg, {}),
                            name: "Режим",
                            value: Belt__Belt_Option.mapWithDefault(org$1.tax, "-", (function (tax) {
                                    return tax.mode_text;
                                  }))
                          },
                          tl: {
                            hd: {
                              icon: JsxRuntime.jsx(ChashierSvg, {}),
                              name: "НДС",
                              value: Belt__Belt_Option.mapWithDefault(org$1.tax, "-", (function (tax) {
                                      if (tax.vat) {
                                        return "есть";
                                      } else {
                                        return "нет";
                                      }
                                    }))
                            },
                            tl: {
                              hd: {
                                icon: JsxRuntime.jsx(Buhta_components__Icons.IconCard.make, {}),
                                name: "Счет",
                                value: Belt__Belt_Option.mapWithDefault(org$1.checking, "не установлено", (function (checking) {
                                        return checking.iban;
                                      }))
                              },
                              tl: {
                                hd: {
                                  icon: JsxRuntime.jsx(AddressSvg, {}),
                                  name: "Адрес",
                                  value: org$1.org.address
                                },
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }),
                JsxRuntime.jsx(HelpChatInfoPanel$ClientInfo$Section, {
                      title: "директор",
                      items: {
                        hd: {
                          icon: JsxRuntime.jsx(Buhta_components__Icons.ResizableSVG.make, {
                                size: "w-5 h-5",
                                children: JsxRuntime.jsx(UserSvg, {})
                              }),
                          name: "ФИО",
                          value: Belt__Belt_Option.mapWithDefault(org$1.director, "-", (function (director) {
                                  return director.short_name;
                                }))
                        },
                        tl: {
                          hd: {
                            icon: JsxRuntime.jsx(PhoneSvg, {}),
                            name: "Телефон",
                            value: Belt__Belt_Option.mapWithDefault(org$1.director, "-", (function (director) {
                                    return director.phone;
                                  }))
                          },
                          tl: {
                            hd: {
                              icon: JsxRuntime.jsx(MailSvg, {}),
                              name: "Email",
                              value: Belt__Belt_Option.mapWithDefault(org$1.director, "-", (function (director) {
                                      return director.email;
                                    }))
                            },
                            tl: /* [] */0
                          }
                        }
                      }
                    }),
                JsxRuntime.jsx(HelpChatInfoPanel$ClientInfo$Section, {
                      title: "ответственные",
                      items: Belt__Belt_List.map(__x, (function (organt) {
                              return {
                                      icon: JsxRuntime.jsx(Buhta_components__Icons.ResizableSVG.make, {
                                            size: "w-5 h-5",
                                            children: JsxRuntime.jsx(UserSvg, {})
                                          }),
                                      name: "Бухгалтер",
                                      value: organt.last_name + (" " + organt.first_name)
                                    };
                            }))
                    })
              ],
              className: "p-6 animate-fadeInRight"
            });
}

const ClientInfo = {
  Section: Section,
  make: HelpChatInfoPanel$ClientInfo
};

function HelpChatInfoPanel(Props) {
  let orgId = Props.orgId;
  const match = React.useState(function () {
        return /* Client */0;
      });
  const currentTab = match[0];
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(HelpChatInfoPanel$PanelHeader, {
                      currentTab: currentTab,
                      setCurrentTab: match[1]
                    }),
                JsxRuntime.jsx("div", {
                      children: currentTab ? JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                              children: "chat notes"
                            }) : JsxRuntime.jsx(HelpChatInfoPanel$ClientInfo, {
                              orgId: orgId
                            }),
                      className: "flex-1 overflow-auto"
                    })
              ],
              className: "h-full flex flex-col"
            });
}

const make$2 = HelpChatInfoPanel;

export {
  Styles ,
  PanelHeader ,
  ClientInfo ,
  make$2 as make,
}
/* Buhta_cabinet__Crm Not a pure module */
